import type { TenantSubscriptionType } from "@/interfaces";
import { useAuthStore } from "@/states";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

/** Polls the logged-in tenant's subscription so admin extensions appear in open sessions. */
export const useTenantSubscriptionQuery = () => {
  const user = useAuthStore((state) => state.user);
  const tenantId = user?.tenant?.id;
  return useQuery({
    queryKey: ["tenant-subscription", tenantId],
    enabled: Boolean(tenantId && user?.role !== "super_admin"),
    queryFn: async (): Promise<TenantSubscriptionType> => (await axios.get("/api/tenants/subscription")).data,
    refetchInterval: 60000,
  });
};
